type StatusName = 'trialing' | 'active' | 'canceled' | 'cable';

export const getTagFromStatus = (status: StatusName) => {
  switch (status) {
    case 'trialing':
      return 'twc_trial_user';
    case 'active':
      return 'twc_subscriber';
    case 'canceled':
      return 'twc_canceled_sub';
    case 'cable':
      return 'twc_cable_user';
    default:
      return '';
  }
};
